namespace Areas.Contact.List {
    "use strict";

    var tabItems = Areas.createTabsWithSameController("Contact", ["Active", "Inactive"], "List");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }


    export function view() {
        gotoSelected("ContactsGrid", "/Contact/Profile/View/");
    }

    export function edit() {
        gotoSelected("ContactsGrid", "/Contact/Profile/Edit/");
    }

    export function showCreate() {
        const createContactDialog = new Areas.Dialogs.CreateContactDialog(() => { });
    }
    

    export function insertRecord(e: any) {
        const form = $("#ContactForm").dxForm("instance");
        const result: any = form.validate();

        if (result.isValid) {
            const newData: any = form.option("formData");
            sendRequest("/Contact/Profile/Post", JSON.stringify(newData), "POST");
        }
    }

    export function getActiveInActive() {
        return $("#filter-type").is(":checked");
    } 

    export function columnViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= '/Contact/Profile/View/{placeholder}'>View</a>";


        buildCellContent(cellElement,
            () => { return cellInfo.data.contactId; },
            linkInfo);
    }
}